<div class="modal-dialog modal-lg modal-fullscreen-md-down modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">
				<strong><%= aee.ap %></strong>
			</h5>
			<button class="btn btn-link d-inline-block d-md-none" style="position:absolute; right:40px; top:8px;" data-bs-toggle="collapse" href="#aee-extra-info"><i class="fa fa-fw fa-lg fa-info-circle"></i></button>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-0">
			<div class="container">
				<div class="row">

					<div class="col-12 col-md-auto p-0" style="background-color:var(--bs-gray-700);">
						<div class="collapse d-md-block" id="aee-extra-info" style="min-width:250px;">

							<div class="text-center mt-2">
								<img src="/assets/ecr/<%- aee.ap.substring(0, 4) %>.png" style="height:80px;" class="img-fluid" alt="" /><br />
								<strong class="text-info"><%= aee.type_name %></strong>
							</div>
							<hr class="mx-4 mt-2 mb-0" style="background-color:rgba(0, 0, 0, 0.4);" />

							<% if (aee?.state?.info) { %>
							<table class="mx-2 mt-2 mb-3" style="font-size:0.8em;">
								<tr>
									<td valign="top" style="width:95px;">Időbélyeg</td>
									<td class="text-info pb-2"><%- aee?.state?.info?.timestamp ? Anvil.moment(aee.state.info.timestamp).format('YYYY.MM.DD HH:mm:ss') + '<br /><span class="text-dim">' + Anvil.moment(aee.state.info.timestamp).fromNow() + '</span>' : '-' %></td>
								</tr>

								<tr>
									<td valign="top">Utolsó lezárt nap</td>
									<td class="text-info"><%= aee?.state?.info?.ZSZAM || '-' %></td>
								</tr>
								<tr>
									<td valign="top">NAV státusz</td>
									<td class="text-info"><%= aee?.state?.info?.NAVState || '-' %></td>
								</tr>
								<tr>
									<td valign="top">NAV utolsó komm.</td>
									<td class="text-info pb-2"><%- aee?.state?.info?.LastNAVSend ? Anvil.moment(aee.state.info.LastNAVSend, 'YYYY.MM.DD. H:mm:ss').format('YYYY.MM.DD HH:mm:ss') + '<br /><span class="text-dim">' + Anvil.moment(aee.state.info.LastNAVSend, 'YYYY.MM.DD. H:mm:ss').fromNow() + '</span>' : '-' %></td>
								</tr>

								<tr>
									<td valign="top">EUR felkészülés</td>
									<td class="text-info"><%- aee?.state?.info?.EURPrepareDate ? Anvil.moment(aee.state.info.EURPrepareDate, 'YYYY.MM.DD. H:mm:ss').format('YYYY.MM.DD') : '-' %></td>
								</tr>
								<tr>
									<td valign="top">EUR átállás</td>
									<td class="text-info"><%- aee?.state?.info?.EURSwitchDate ? Anvil.moment(aee.state.info.EURSwitchDate, 'YYYY.MM.DD. H:mm:ss').format('YYYY.MM.DD') : '-' %></td>
								</tr>
								<tr>
									<td valign="top">HUF kivezetés</td>
									<td class="text-info"><%- aee?.state?.info?.HUFTermDate ? Anvil.moment(aee.state.info.HUFTermDate, 'YYYY.MM.DD. H:mm:ss').format('YYYY.MM.DD') : '-' %></td>
								</tr>
								<tr>
									<td valign="top">EUR/HUF árfolyam</td>
									<td class="text-info pb-2"><%= aee?.state?.info?.HUFEURExchangeRate || '-' %></td>
								</tr>

								<tr>
									<td valign="top" colspan="2" style="color:burlywood;">
										<i class="fa fa-hdd me-2"></i><strong>AEE</strong>
									</td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">Típus</td>
									<td class="text-info"><%= aee?.state?.info?.AEETYpe || '-' %></td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">HW verzió</td>
									<td class="text-info"><%= aee?.state?.info?.AEEHWVersion || '-' %></td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">FW verzió</td>
									<td class="text-info pb-2"><%= aee?.state?.info?.AEEFWVersion || '-' %></td>
								</tr>

								<tr>
									<td valign="top" colspan="2" style="color:burlywood;">
										<i class="fa fa-broadcast-tower me-2"></i><strong>GSM modul</strong>
									</td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">Típus</td>
									<td class="text-info"><%= aee?.state?.info?.GSMINFO || '-' %></td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">IMEI</td>
									<td class="text-info"><%= aee?.state?.info?.IMEI || '-' %></td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">SW verzió</td>
									<td class="text-info"><%= aee?.state?.info?.GSMSW || '-' %></td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">Szolgáltató</td>
									<td class="text-info"><%= aee?.state?.info?.GSMServiceInfo || '-' %></td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">Jelerősség</td>
									<td class="text-info"><%= aee?.state?.info?.GSMSignal || '-' %></td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">APN státusz</td>
									<td class="text-info pb-2"><%= aee?.state?.info?.APNState || '-' %></td>
								</tr>

								<tr>
									<td valign="top" colspan="2" style="color:burlywood;">
										<i class="fa fa-sim-card me-2"></i><strong>SIM kártya</strong>
									</td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">SIM kibocsátó</td>
									<td class="text-info"><%= aee?.state?.info?.SIM || '-' %></td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">ICC ID</td>
									<td class="text-info"><%= aee?.state?.info?.GSMICCID || '-' %></td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">IMSI</td>
									<td class="text-info pb-2"><%= aee?.state?.info?.IMSI || '-' %></td>
								</tr>


								<tr>
									<td valign="top" colspan="2" style="color:burlywood;">
										<i class="fa fa-sd-card me-2"></i><strong>SD kártya</strong>
									</td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">Szabad hely</td>
									<td class="text-info pb-2"><%= aee?.state?.info?.SDFree ? Anvil.numeral(aee.state.info.SDFree * 1024).format('0.00 b') : '-' %> / <%= aee?.state?.info?.SDSize ? Anvil.numeral(aee.state.info.SDSize * 1024).format('0.00 b') : '-' %></td>
								</tr>

								<tr>
									<td valign="top" colspan="2" style="color:burlywood;">
										<i class="fa fa-battery-full me-2"></i><strong>Akkumulátor</strong>
									</td>
								</tr>
								<tr>
									<td class="ps-2" valign="top">Feszültség</td>
									<td class="text-info"><%= aee?.state?.info?.ACCVoltage ? aee.state.info.ACCVoltage + ' V' : '-' %></td>
								</tr>
							</table>
							<% } %>

						</div>
					</div>

					<div class="col p-0">

						<!-- Tab navigation -->
						<ul class="nav nav-pills m-2">
							<li class="nav-item">
								<button class="nav-link active" data-bs-toggle="tab" data-bs-target="#aee-tab-base" type="button">Alapadatok</button>
							</li>
							<li class="nav-item">
								<button class="nav-link" data-bs-toggle="tab" data-bs-target="#aee-tab-binding" type="button">Társítás</button>
							</li>
							<li class="nav-item">
								<button class="nav-link <% if (!(aee.ap.startsWith('A282') || aee.ap.startsWith('A295') || aee.ap.startsWith('A318') || aee.ap.startsWith('Y006'))) { %>disabled<% } %>" data-bs-toggle="tab" data-bs-target="#aee-tab-licence" type="button">Licenc</button>
							</li>
						</ul>

						<hr class="m-0" />

						<!-- Tab content -->
						<div class="tab-content" id="aee-tab-content">

							<!-- Alapadatok tab -->
							<div class="tab-pane p-3 show active" id="aee-tab-base" role="tabpanel" aria-labelledby="alapadatok-tab">
								<%- include('/ui/form', {
									params: [ 'aee', aee ],
									fields: [
										{
											type: 'text',
											name: 'ap',
											title: 'AP',
											attributes: (aee.id !== null) ? {
												readonly: true
											} : {}
										},
										{
											type: 'select',
											name: 'operator_service_id',
											title: 'Kezelő szerviz',
											help: 'A szerviz, aki a pénztárgépet kezeli a greenpenben, és aki az ügyféllel kapcsolatban áll.',
											params: {
												maxItems: 1,
												options: companies.data.filter(x => x.service_partner == 1),
												valueField: 'id',
												labelField: 'name',
												searchField: [ 'tax_number', 'name' ],
												render: {
													item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
													option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
												}
											},
											unset_value: null
										},
										{
											type: 'select',
											name: 'partner_service_id',
											title: 'Karbantartó szerviz',
											help: 'A szerviz, aki a pénztárgéphez közel van, és aki a karbantartást végzi.',
											params: {
												maxItems: 1,
												options: companies.data.filter(x => x.service_partner == 1),
												valueField: 'id',
												labelField: 'name',
												searchField: [ 'tax_number', 'name' ],
												render: {
													item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
													option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
												}
											},
											unset_value: null
										},
										{
											type: 'html',
											content: '<br />'
										},
										{
											type: 'switch',
											name: 'suspended',
											title: 'Felfüggesztve',
											description: 'A pénztárgép üzemen kívül van helyezve.'
										},
										{
											type: 'html',
											content: '<br />'
										},
										{
											type: 'textarea',
											name: 'notes',
											title: 'Megjegyzések',
											attributes: {
												style: 'height:220px;'
											}
										}
									]
								}) %>
							</div>

							<!-- Társítás tab -->
							<div class="tab-pane p-3" id="aee-tab-binding" role="tabpanel" aria-labelledby="tarsitas-tab">
								<%- include('/ui/form', {
									params: [ 'aee_link_1', aee ],
									fields: [
										{
											type: 'select',
											name: 'link',
											title: 'Társítás',
											params: {
												options: [
													{ value: 'terminal', label: 'Terminálhoz rendelt' },
													{ value: 'company', label: 'Céghez rendelt' }
												],
												valueField: 'value',
												labelField: 'label',
											},
											unset_value: null,
											update: (value) => {
												// Reset values
												if (value == 'company') {
													Anvil.page.modal.aee.site_id = null
													Anvil.page.modal.aee.terminal_id = null
												}

												// Re-render this form-group
												Anvil.render('/c_order/aee/modal_edit_panel_link', { aee: Anvil.page.modal.aee }, '#panel-link')
											}
										},
										{
											type: 'select',
											name: 'company_id',
											title: 'Cég',
											params: {
												maxItems: 1,
												options: Anvil.page.modal.companies.data,
												valueField: 'id',
												labelField: 'name',
												searchField: [ 'tax_number', 'name' ],
												render: {
													item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
													option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
												}
											},
											unset_value: null,
											update: (value) => {
												// Reset values
												if (Anvil.page.modal.aee.terminal_id) {
													const selected_terminal	= Anvil.page.terminals.getByMachineId(Anvil.page.modal.aee.terminal_id)
													if (selected_terminal.company_id != value) {
														// The selected terminal does not belong to the selected company
														Anvil.page.modal.aee.terminal_id = null
													}
												}

												// Re-render this form-group
												Anvil.render('/c_order/aee/modal_edit_panel_link', { aee: Anvil.page.modal.aee }, '#panel-link')
											}
										}
									]
								}) %>
								<div id="panel-link">
									<%- include('/c_order/aee/modal_edit_panel_link', { aee }) %>
								</div>
							</div>

							<!-- Licenc tab -->
							<% if (aee.ap.startsWith('A282') || aee.ap.startsWith('A295') || aee.ap.startsWith('A318') || aee.ap.startsWith('Y006')) { %>
							<div class="tab-pane p-3" id="aee-tab-licence" role="tabpanel" aria-labelledby="licenc-tab">

								<%- include('/ui/form', {
									params: [ 'aee', aee ],
									fields: [
										{
											type: 'text',
											name: 'licence',
											title: 'Licenc kód',
											help: 'Ez a c-Order által utoljára jelentett licenc kód.',
											attributes: {
												readonly: true
											}
										}
									]
								}) %>

								<div id="licence_info">
									<%- include('/c_order/aee/panel_licence', { ap: aee.ap, licence: aee.licence }) %>
								</div>

								<hr class="my-4" />

								<%- include('/ui/form', {
									params: [ 'aee', aee ],
									fields: [
										{
											type: 'text',
											name: 'licence_to_upload',
											title: 'Új licenc kód',
											help: 'Az itt megadott licenc kódot a c-Order egy percen belül automatikusan letölti (ha fut), és bemásolja a megfelelő helyre.',
											update: (value, name, data) => {
												// Re-render this form-group
												Anvil.render('/c_order/aee/panel_licence', { ap: data.ap, licence: value }, '#licence_to_upload_info')
											}
										}
									]
								}) %>

								<div id="licence_to_upload_info">
									<%- include('/c_order/aee/panel_licence', { ap: aee.ap, licence: aee.licence_to_upload }) %>
								</div>
							</div>
							<% } %>
						</div>

					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer justify-content-between">
			<button type="button" class="btn btn-dark" style="color:tan;" onclick="Anvil.page.modal.issue()"><i class="fa fa-briefcase me-2"></i>Új munkalap</button>

			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-check me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async issue () {
		const terminal = await Anvil.models.c_order.Terminal.fetch(Anvil.page.modal.aee.terminal_id)
		Anvil.page.modal.close()
		Anvil.exec('issue/modal_edit', null, {
			link: 'aee',
			company_id: Anvil.page.modal.aee.company_id,
			company_db_id: terminal?.company_db_id || null,
			site_id: terminal?.site_id || null,
			terminal_id: Anvil.page.modal.aee.terminal_id,
			aee_id: Anvil.page.modal.aee.id
		})
	},

	async save () {
		const res = await Anvil.exec('c_order/aee/action_save', Anvil.page.modal.aee)

		if (res === true) {

			// Refresh list
			if ('refresh' in Anvil.page) {
				Anvil.page.refresh()
			}

			// Focus on aee
			/*
			let grid = Anvil.models.components.Grid.find('#aee_grid')
			grid.select(grid.list.getById(aee.id), true)
			*/

			// Close modal
			Anvil.page.modal.close()
		}
	}
})
</script>
